import dayjs from "dayjs";
import React from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import tw from "tailwind-styled-components";
import { loadSingleStaff } from "../../redux/rtk/features/user/userSlice";
import { deleteDesHistory } from "../designationHistory/designationHistoryApis";
import DesignationTimelineSvg from "./DesignationTimelineSVG";
import DesignationEditSinglePopup from "./PopUp/DesignationEditSinglePopup";
import DepartmentEditSinglePopup from "./PopUp/DepartmentEditSinglePopup";

const EmployeeDepartment = ({ list, edit, setLoading }) => {
  // console.log("list", list);

  const user_id = useParams("id");
  const dispatch = useDispatch();

  const deletedDesignationHistory = async (id) => {
    setLoading(true);
    const { data } = await deleteDesHistory(id);

    // check if data is deleted or not and call the setPopUp function
    if (data) {
      dispatch(loadSingleStaff(user_id.id));
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  // Convert a single object to an array if it's not already an array
  const departmentList = Array.isArray(list) ? list : list ? [list] : [];
  // console.log("departmentList", departmentList);

  return (
    <div>
      <main className="container mx-auto w-full flex justify-center mt-5">
        <ol className="border-l-2 border-slate-600">
          {departmentList.length > 0 &&
            departmentList.map((item, index) => {
              return (
                <li key={index}>
                  <div className="md:flex flex-start">
                    <DesignationTimelineSvg />
                    <div className="block p-6 max-w-md ml-6 mb-5">
                      <div className="flex justify-between mb-4">
                        <Heading>{item?.DepartmentName}</Heading>

                        <Heading>
                          {dayjs(item?.EffectedFrom).format("MMM YYYY")} -{" "}
                          {item?.EffectedTo
                            ? dayjs(item?.EffectedTo).format("MMM YYYY")
                            : "Present"}
                        </Heading>
                        {edit && (
                          <div>
                            <DepartmentEditSinglePopup
                              data={item}
                              setLoading={setLoading}
                            />

                            <button
                              onClick={() =>
                                deletedDesignationHistory(
                                  item.DepartmentHistoryId
                                )
                              }
                            >
                              {/* <BtnDeleteSvg size={20} 
                                                            /> */}
                            </button>
                          </div>
                        )}
                      </div>

                      {/* <Heading1>
                        Comment : <Heading2>{item?.comment || "N/A"}</Heading2>
                      </Heading1> */}
                      <Heading1 className="">
                        Start Date :{" "}
                        <Heading2>
                          {" "}
                          {item?.EffectedFrom
                            ? dayjs(item?.EffectedFrom).format("DD/MM/YYYY")
                            : "N/A"}
                        </Heading2>
                      </Heading1>

                      <Heading1 className="">
                        End Date :{" "}
                        <Heading2>
                          {item?.EffectedTo
                            ? dayjs(item?.EffectedTo).format("DD/MM/YYYY")
                            : "Present"}
                        </Heading2>
                      </Heading1>

                      <Heading1 className="">
                        Department :{" "}
                        <Heading2>{item?.DesignationName || "N/A"}</Heading2>
                      </Heading1>

                      
                    </div>
                  </div>
                </li>
              );
            })}

          {departmentList.length === 0 && (
            <div className="p-4 text-center">
              No department history available
            </div>
          )}
        </ol>
      </main>
    </div>
  );
};

const Heading = tw.h3`
font-medium
text-base
mr-20
w-500
txt-color-2
         `;

const Heading1 = tw.h3`
font-medium
text-sm
mr-20
w-500
txt-color-2
         `;

const Heading2 = tw.span`
font-medium 
text-sm
txt-color-secondary`;

export default EmployeeDepartment;
